// eslint-disable-next-line max-len
import { OrderSummaryHeaderComponent as HeaderComponent } from '../../../checkout/modules/checkout-shared/components/order-summary-header/order-summary-header.component';
import { AddressSummaryComponent } from '../address-summary/address-summary.component';
import { IconComponent } from '../icon/icon.component';
import { OrderProductListComponent } from '../order-product-list/order-product-list.component';
import { PriceSummaryComponent } from '../price-summary/price-summary.component';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { faPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';

export interface OrderSummaryOptions {
	showOrderDetails?: boolean;
	showOrderStatus?: boolean;
	showCopyToBasket?: boolean;
	showPrices?: boolean;
	isConfirmedOrder?: boolean;
}

/** A component that displays a summary of an order. */
@Component({
	imports: [
		PriceSummaryComponent,
		IconComponent,
		AddressSummaryComponent,
		HeaderComponent,
		OrderProductListComponent,
	],
	selector: 'g-order-summary',
	templateUrl: './order-summary.component.html',
	styleUrls: ['./order-summary.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryComponent {
	readonly order$ = input.required<api.OrderDto>({ alias: 'order' });
	readonly options$ = input<OrderSummaryOptions | undefined>(undefined, { alias: 'options' });

	readonly icons = { faPrint };

	/** Print the order summary. */
	printReceipt(): void {
		print();
	}
}
